
import { SEARCH_OPTION } from "./SearchOption.jsx";

export const  DROPDOWN_OPTION = {

    PAID_STATUS : [
     { name: 'ALL INVOICE', code: 0 },
     { name: 'UNPAID', code: 1 },
     { name: 'PARTIAL PAID', code: 2 },
     { name: 'FULLY PAID', code: 3 },
     {name:'CREDIT INVOICE' , code:5},
     {name:'SETTLED INVOICE' , code:6}
   ],

   CHEQUE_DATE : [
    { name: 'PAYMENT DATE', code: 0 },
    { name: 'DEPOSIT DATE', code: 1 }
  ],


   TOTAL_BY:[
    {name:'TOTAL BY COST PRICE', code:0},
    {name:'TOTAL BY RETAIL PRICE', code :1}

   ],

   SEARCH_BY:[
    {name:'Barcode', code:SEARCH_OPTION.BARCODE},
    {name:"Name",code: SEARCH_OPTION.NAME},
    {name:"Description", code:SEARCH_OPTION.DESCRIPTION},
    // {name:"Category",code:SEARCH_OPTION.CATEGORY},
    // {name:"Brande", code:SEARCH_OPTION.BARND},
   ],

   PAY_OFF_INVOICES:[
    {name:"Pay off invoices", value:true}
   ]
}
